<template>
  <OneColumnLayout
    :container="false"
    ref="layout"
  >
      <Navbar
        ref="header"
        slot="navbar"
        @drawer:toggle="drawer = !drawer"
        @menuitem-logout="logout"
        @search-global='searchGlobal'
        @menuitem-surveyapp="surveyapp = true, drawer = false"
      />

      <NavigationDrawer
        v-if="!runningOnMobileDevice"
        slot="drawer"
        :drawer="drawer"
        :locked="locked"
        @input="drawer = $event"
        @locked="locked = $event"
        @menuitem-legaldisclaimer="legalDisclaimer = true, drawer = false"
      />

      <BottomNavigationBar
        v-else
        slot="drawer"
        :drawer="drawer"
      />
      <v-parallax
        src="@/assets/background.svg"
        height="inherit"
        >
        <div v-if="!navInternal">
          <router-view v-touch="{
            // left: () => swipe('Left'),
            // right: () => swipe('Right'),
            // up: () => drawer = true,
            down: () => drawer = false,
          }"></router-view>
        </div>
        <div v-else>
          <component :is=currentView :id=currentPathId :publicView=publicView :key=currentPathId
            :internalAccess=internalAccess>
          </component>
        </div>
      </v-parallax>
      <!-- <LegalDisclaimer
        v-if="legalDisclaimer"
        :visible="legalDisclaimer"
        @close="legalDisclaimer = $event"
      ></LegalDisclaimer> -->

      <SurveyApp
        v-if="surveyapp"
        :visible="surveyapp"
        @close="surveyapp = false"
        @message="opensnackbar"
      ></SurveyApp>

      <Messages
        id="messages-panel"
        :messages="messages"
        :style="{ top: ($refs.header ? $refs.header.$el.style.height : '64px')  }"
        v-bind:class="{ 'pa-0': !messages.length }"
      ></Messages>

      <v-snackbar
        v-model="snackbar"
        top
        :color="color"
        multi-line
        timeout="3000"
      >
        {{ message }}
      </v-snackbar>
  </OneColumnLayout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
// @ is an alias to /src
import { OneColumnLayout } from '@/layouts';
import {
  Navbar, NavigationDrawer, BottomNavigationBar, Messages,
} from '@/components';
import internalRoutes from '@/plugins/vue-constants/internalRoutes';

export default {
  name: 'MainView',
  components: {
    OneColumnLayout,
    Navbar,
    NavigationDrawer,
    BottomNavigationBar,
    Messages,
    internalRoutes,
    SurveyApp: () => import(/* webpackChunkName: "surveyapp" */ '@/views/SurveyApp.vue'),
  },
  data() {
    return {
      publicView: false,
      internalAccess: true,
      drawer: true,
      lastScrollPosition: null,
      throttleDrawer: null,
      throttleScrollPosition: null,
      locked: false,
      surveyapp: false,
      // on drawer lock main content is padded on left but
      // on drawer unlock main content still padded on left
      // unkown if thats an issue but must be handled manually
      lockedContainerPaddingControl: { locked: null, unlocked: null },
      message: null,
      snackbar: false,
      color: null,
    };
  },
  watch: {
    // here is the main content padding handling
    locked(newVal) {
      const { layout = {} } = this.$refs; // oneColumnLayout ref
      const { main } = (layout.$refs || {}); // vMain ref

      if (main) {
        const { $el: { style } } = main;
        const getKey = (v) => (v ? 'locked' : 'unlocked');
        const key = getKey(newVal);
        const oppositeKey = getKey(!newVal);
        if (this.lockedContainerPaddingControl[key] === null) {
          this.lockedContainerPaddingControl[key] = style.paddingLeft;
        }
        if (this.lockedContainerPaddingControl[oppositeKey] !== null) {
          style.paddingLeft = this.lockedContainerPaddingControl[oppositeKey];
        }
      }
      this.$store.dispatch('globalState/setLocalItem', {
        key: 'blockNavigator',
        value: newVal,
      });

      const evento = new Event('eventoLockWindow');
      window.dispatchEvent(evento);
      return newVal;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('session/logout')
        .then(() => this.$router.go()) // forcing reload to let router redirect to login
        .catch((err) => console.error(err));
    },
    searchGlobal(evt) {
      const { q = '' } = evt || {};
      if (q !== '') {
        this.$router.push(`/search?q=${q}`)
          .catch(() => {});
      } else {
        throw new Error('Error al consultar el dato (MainView.SearchGlobal). Dato no valido');
      }
    },
    opensnackbar(evt) {
      this.message = evt.message;
      this.color = evt.color;
      this.snackbar = !this.snackbar;
    },
    handleScroll(evt) {
      const currentScrollPosition = window.scrollY;
      if (this.lastScrollPosition == null) {
        this.lastScrollPosition = currentScrollPosition;
      } else {
        const diff = Math.abs(this.lastScrollPosition - currentScrollPosition);
        const direction = this.lastScrollPosition == null || this.lastScrollPosition < currentScrollPosition ? 'bottom' : 'top';

        evt.stopPropagation();
        evt.stopImmediatePropagation();
        if ((!this.drawer && (this.bottomReached || currentScrollPosition === 0 || (direction === 'top' && diff > 30))) || (this.drawer && direction === 'bottom' && diff > 30 && currentScrollPosition > 60)) {
          this.throttleDrawer(!this.drawer);
        }
        this.throttleScrollPosition(currentScrollPosition);
      }
    },
  },
  computed: {
    ...mapState({
      messages: ({ messages: { list } }) => list,
    }),
    ...mapGetters({
      get: 'globalState/get',
      currentPath: 'routeState/getCurrentPath',
      currentPathId: 'routeState/getCurrentPathId',
      navInternal: 'routeState/getNavInternal',
    }),
    runningOnMobileDevice() {
      return this.$vuetify.breakpoint.smAndDown;
      // return typeof this.get('deviceOS') === 'string';
    },
    bottomReached() {
      const documentHeight = document.body.getClientRects()[0].height;
      const currentScrollY = window.scrollY + window.innerHeight;
      return currentScrollY === documentHeight;
    },
    currentView() {
      const currentPath = this.currentPath === 'element' ? 'catalog-forms' : this.currentPath;
      return internalRoutes.routes[currentPath];
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    this.throttleDrawer = this.$throttle((drawer) => {
      this.$nextTick(() => {
        if (this.drawer !== drawer) {
          this.drawer = drawer;
        }
        // console.log('updated scroll state, drawer', drawer);
      });
    }, 300);

    this.throttleScrollPosition = this.$throttle((scrollPosition) => {
      this.lastScrollPosition = scrollPosition;
      // console.log('updated scroll state, lastScrollPosition', scrollPosition);
    }, 500);

    // iOS loaded event dispatch
    if (window.webkit && window.webkit.messageHandlers.pageLoadedEvent) {
      console.log('triggering event to webkit message hander: pageLoadedEvent("dashboard")');
      window.webkit.messageHandlers.pageLoadedEvent.postMessage('dashboard');
    }

    this.$root.$on('search-global-home', (e) => {
      this.searchGlobal(e);
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  async mounted() {
    this.locked = this.get('blockNavigator') || false;
    console.log('vuetify', this.$vuetify);
  },
};
</script>

<style lang="scss" scoped>
  $messages-panel-width: 400px;
  $messages-panel-padding: 1rem;

  #messages-panel {
    position: fixed;
    right: 0;
    width: $messages-panel-width;
    max-width: 100%;
    padding: $messages-panel-padding;
  }
</style>

<style lang="scss">
$gradient_sequence: #01968B, #0D9B83, #2DA76E, #62BC4C, #A3D521;

.w-100 {
  width: 100%;
}

.v-application--wrap {
  width: 100% !important;
}

.v-menu__content--fixed {
  min-width: 200px !important;
}

.v-list-item__title, .v-list-item__subtitle {
  flex: 1 1 100% !important;
  -ms-flex: 1 1 100% !important;
}

.maxw-1750 {
  max-width: 1750px !important;
}

.v-application .gradient-button {
  background: -webkit-linear-gradient(45deg, $gradient_sequence);
  background: -o-linear-gradient(45deg, $gradient_sequence);
  background: linear-gradient(45deg, $gradient_sequence);
}

.v-application .v-parallax {
  min-height: 100%;
  overflow-y: auto;

  & .v-parallax__content {
    color: #333333;
    padding: 0;
  }
}
</style>
